var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.234 11.864a9.883 9.883 0 11.795 3.904M16.813 14.538l-3.672-2.687V6.02",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.987 10.059l-2.992 2L1 9.068",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0zLjIzMzY3IDExLjg2MzhDMy4yMzg0OCA5LjQxNTk3IDQuMTUxNSA3LjA1NzAyIDUuNzk1OTEgNS4yNDM4MUM3LjQ0MDMzIDMuNDMwNiA5LjY5OTEyIDIuMjkyMTQgMTIuMTM0OCAyLjA0ODkzQzE0LjU3MDUgMS44MDU3MSAxNy4wMDk4IDIuNDc1MDUgMTguOTgwMyAzLjkyNzNDMjAuOTUwOCA1LjM3OTU1IDIyLjMxMjMgNy41MTEzOCAyMi44MDEgOS45MDk5MkMyMy4yODk3IDEyLjMwODUgMjIuODcxIDE0LjgwMyAyMS42MjU4IDE2LjkxMDVDMjAuMzgwNyAxOS4wMTggMTguMzk3NyAyMC41ODg0IDE2LjA2MTEgMjEuMzE3NkMxMy43MjQ0IDIyLjA0NjggMTEuMjAwMiAyMS44ODMgOC45Nzc0MyAyMC44NTc3QzYuNzU0NjUgMTkuODMyNSA0Ljk5MTQyIDE4LjAxODkgNC4wMjkyMiAxNS43NjgxIiBzdHJva2U9ImN1cnJlbnQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE2LjgxMzEgMTQuNTM4TDEzLjE0MTMgMTEuODUxNVY2LjAxOTUzIiBzdHJva2U9ImN1cnJlbnQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTUuOTg3NDggMTAuMDU4NUwyLjk5NDk5IDEyLjA1OTZMMSA5LjA2NzE0IiBzdHJva2U9ImN1cnJlbnQiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgHistory as ReactComponent };